"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringArrayTransformersModule = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../ServiceIdentifiers");
const NodeTransformer_1 = require("../../../enums/node-transformers/NodeTransformer");
const StringArrayRotateFunctionTransformer_1 = require("../../../node-transformers/string-array-transformers/StringArrayRotateFunctionTransformer");
const StringArrayScopeCallsWrapperTransformer_1 = require("../../../node-transformers/string-array-transformers/StringArrayScopeCallsWrapperTransformer");
const StringArrayTransformer_1 = require("../../../node-transformers/string-array-transformers/StringArrayTransformer");
exports.stringArrayTransformersModule = new inversify_1.ContainerModule((options) => {
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(StringArrayRotateFunctionTransformer_1.StringArrayRotateFunctionTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.StringArrayRotateFunctionTransformer);
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(StringArrayScopeCallsWrapperTransformer_1.StringArrayScopeCallsWrapperTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.StringArrayScopeCallsWrapperTransformer);
    options.bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(StringArrayTransformer_1.StringArrayTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.StringArrayTransformer);
});
